const redirect_uri = `${globalThis.location.origin}/curity`;

export function curityAuthParams(client_id: string) {
	return {
		client_id,
		redirect_uri,
		response_type: 'code',
		scope: 'ipa.readwrite profile'
	};
}

export function curityTokenParams(client_id: string, client_secret: string, code: string) {
	return {
		code,
		client_id,
		client_secret,
		redirect_uri,
		grant_type: 'authorization_code'
	};
}
